import React from 'react'

const Line = ({field_column}) => {
    return (        
<div className={`${field_column? field_column:'col-lg-12'} form-group`}><hr/></div>
    )
}

export default Line
